export default __webpack_public_path__ + "static/media/teaser-low.1e256c96.gif";